import { Heading } from '@chakra-ui/react';
import BankTVRandCVRDataTableHandler from '../../containers/dataTableHandlers/base/bankTVRandCVRParam/BankTVRandCVRDataTableHandler';

const BankTerminalVerificationResultPage = () => {
  return (
    <>
      <Heading size="md" mb={"2rem"}>Bank Terminal Verification Results</Heading>
      <BankTVRandCVRDataTableHandler type='Terminal' />
    </>
  )
};

export default BankTerminalVerificationResultPage; 